module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      basket: true, flipToggle: true, active: _vm.active
    }
  }, [(!_vm.hasPictureWall) ? _c('div', {
    staticClass: "title tiny-heading"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$t("needsPictureWall")) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.hasPictureWall) ? _c('div', {
    staticClass: "title tiny-heading"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$t("clickToPickMotif")) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.hasArticles) ? _c('div', {
    staticClass: "chosenArticles"
  }, _vm._l((_vm.articles), function(article, index) {
    return (article) ? _c('div', {
      key: index,
      staticClass: "article"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('img', {
      attrs: {
        "src": _vm.getArticleImage(article)
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "name ellipsis"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('div', {
      class: {
        originalPrice: true, oldPrice: article.campaignPrice
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(article.price) + "\n\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencySuffix'))
      }
    })]), _vm._v(" "), (article.campaignPrice) ? _c('div', {
      class: {
        newPrice: true
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(article.campaignPrice) + "\n\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencySuffix'))
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.removeProduct(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]) : _vm._e()
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-625e08d0!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Basket/Basket.vue
// module id = 163
// module chunks = 0